<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Conference Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="conference.title" maxlength="250"></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Code" label-position="inside">
                        <b-input v-model="conference.code" v-mask="'NNNNNNNNNNNNNNN'" maxlength="20"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field label="Location" label-position="inside">
                        <b-input v-model="conference.location"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column is-4">
                    <b-field label="Start Date" label-position="inside">
                        <b-datepicker
                            v-model="conference.start"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datepicker>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="End Date" label-position="inside">
                        <b-datepicker
                            v-model="conference.end"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datepicker>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Registration Closed Date" label-position="inside">
                        <b-datepicker
                            v-model="conference.close"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datepicker>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field label="Conference Image/Logo (URL)" label-position="inside">
                        <b-input v-model="conference.logo" placeholder="https:// ..."></b-input>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Registration Limit" label-position="inside">
                        <b-input v-model="conference.registration_cap"></b-input>
                    </b-field>
                </div>
            </div>

        </container-list-item>

        <container-list-item padded no-border>
            <b-field label="Description" message="Description is displayed on main registration page.">
                <quill-editor v-model="conference.description" ref="descriptionEditor" :options="editorOptions" class="has-background-white content"/>
            </b-field>
        </container-list-item>

        <container-list-item padded no-border>
            <b-field label="Information" message="Information is displayed to registrants once they are successfully registered.">
                <quill-editor v-model="conference.information" ref="informationEditor" :options="editorOptions" class="has-background-white content"/>
            </b-field>
        </container-list-item>

        <subheader-list-item icon="fa-credit-card" title="Registration Options"/>
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field><b-switch v-model="conference.no_phone" true-value="0" false-value="1">Collect Phone Number(s)</b-switch></b-field>
                    <b-field><b-switch v-model="conference.no_address" true-value="0" false-value="1">Collect Address</b-switch></b-field>
                    <b-field><b-switch v-model="conference.wa_edu" true-value="true" false-value="false">Collect Washington School/District</b-switch></b-field>
                </div>
                <div class="column">
                    <b-field><b-switch v-model="conference.allow_cc" true-value="true" false-value="false">Accept Credit Card registrations.</b-switch></b-field>
                    <b-field><b-switch v-model="conference.allow_po" true-value="true" false-value="false">Accept Purchase Order (P.O.) registrations.</b-switch></b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-file-alt" title="Purchase Order (P.O.) Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column is-8">
                    <b-field label="Mail To" label-position="inside">
                        <b-input v-model="conference.po_mail_to"></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Attention To" label-position="inside">
                        <b-input v-model="conference.po_attn_to"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-8">
                    <b-field label="Address" label-position="inside">
                        <b-input v-model="conference.po_address_1"></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Address 2" label-position="inside">
                        <b-input v-model="conference.po_address_2"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-5">
                    <b-field label="City" label-position="inside">
                        <b-input v-model="conference.po_city"></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="State" label-position="inside">
                        <b-select v-model="conference.po_state" expanded>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Zip" label-position="inside">
                        <b-input v-model="conference.po_zip"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Email Address" label-position="inside">
                        <b-input v-model="conference.po_email"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="P.O. Instructions" label-position="inside">
                        <b-input type="textarea" v-model="conference.po_instructions"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'RmcConferenceForm',
        props: {
            conference: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
